import { Trans, useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

const useStyles = makeStyles({
  fakturowniaWarehouseTooltip: {
    marginBlockStart: 0,
    marginBlockEnd: 0,
    paddingInlineStart: '1em',
  },
});

const WarehousePriceModeTooltip = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {t('form.field.warehousePriceMode.label')}
      <InfoIconTooltip
        title={
          <Trans
            i18nKey="form.field.warehousePriceMode.tooltip"
            components={{
              ul: <ul className={classes.fakturowniaWarehouseTooltip} />,
              li: <li />,
            }}
          />
        }
      />
    </>
  );
};

export default WarehousePriceModeTooltip;
